export function getEmptyCellContent() {
  return '--';
}
